import { useMemo } from "react";
import { selectors, useAppSelector } from "store";
export var useCupOptions = function (nodes, cupFamilies) {
    var _a;
    var nodeIds = useMemo(function () { return nodes.map(function (node) { return node.id; }); }, [nodes]);
    var selectedCups = useAppSelector(selectors.selectSelectedCups(nodeIds));
    var systemDataDefineParameters = useAppSelector(selectors.selectSystemDataDefineParameters);
    var cupOptions = useMemo(function () {
        if (!(systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.suctionCupComponents))
            return [];
        var isShowingCupFamily = function (cup) {
            return !cupFamilies.length ||
                cupFamilies.includes(cup.cupFamily) ||
                cup.cupFamily === "";
        };
        var stripNumbers = function (s) { return s.replace(/\d/g, ""); };
        var cupOptionsList = Object.values(systemDataDefineParameters.suctionCupComponents)
            .filter(function (component) { return component.valid && isShowingCupFamily(component); })
            .sort(function (c1, c2) {
            /* Group by label structure (numbers stripped) */
            var labelCompare = stripNumbers(c1.label).localeCompare(stripNumbers(c2.label));
            if (labelCompare !== 0)
                return labelCompare;
            /* Then smallest size first */
            return c1.width - c2.width;
        })
            .sort(function (c1, c2) {
            /* Stable sort by cup family to group families together */
            return c1.cupFamily.localeCompare(c2.cupFamily);
        });
        return cupOptionsList;
    }, [cupFamilies, systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.suctionCupComponents]);
    var allCupComponents = useMemo(function () {
        return (systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.suctionCupComponents)
            ? Object.values(systemDataDefineParameters.suctionCupComponents)
            : [];
    }, [systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.suctionCupComponents]);
    var selectedCupOptions = useMemo(function () {
        return allCupComponents.filter(function (option) {
            return option.value &&
                selectedCups.map(function (cup) { return cup === null || cup === void 0 ? void 0 : cup.value; }).includes(option.value);
        });
    }, [allCupComponents, selectedCups]);
    var selectedCupImage = (_a = selectedCups[0]) === null || _a === void 0 ? void 0 : _a.image;
    return { cupOptions: cupOptions, selectedCupOptions: selectedCupOptions, selectedCupImage: selectedCupImage };
};
